import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  jobName: 'JobName',
  DateGeneratedFrom: 'DateGeneratedFrom',
  DateGeneratedTo: 'DateGeneratedTo',
  reportTypeID: 'ReportType',
  project: 'project',
  ReportsFor: 'ReportsFor',
  clientSampleNo: 'clientSampleNo',
  SampleName: 'SampleName',
  productGrade: 'productGrade',
  Location: 'Location',
  Client: 'Client',
  Contract: 'Contract',
};

const initialFilterState = {
  JobName: '',
  DateGeneratedFrom: null,
  DateGeneratedTo: null,
  ReportType: '',
  Location: null,
  Client: null,
  selectedSourceSystems: null,
  project: null,
  ReportsFor: null,
  clientSampleNo: '',
  SampleName: '',
  productGrade: null,
  Contract: null,
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'GeneratedOn',
  sortDirection: SortDirection.Asc,
};

export const sliceName = 'reportSearch';
const reportSearchSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState
});

export const reportSearchActions = reportSearchSlice.actions;
export default reportSearchSlice.reducer;
